interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  return (
    <nav
      className="mt-10 flex items-center justify-center gap-2"
      aria-label="分页导航"
    >
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-800 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-300 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-800 disabled:hover:text-foreground-300"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`h-9 min-w-9 rounded-md px-3 font-label text-sm transition-colors ${
            p === current
              ? "bg-primary-500 font-semibold text-background-50"
              : "border border-background-800 text-foreground-300 hover:border-primary-500 hover:text-primary-300"
          }`}
          aria-current={p === current ? "page" : undefined}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-800 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-300 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-800 disabled:hover:text-foreground-300"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}